export const commonFiltersPrefixedData = {
  entity: [{ value: '', label: 'Overall' }],
  businessUnits: [{ value: '', label: 'Overall' }],
  agreementTypes: [{ value: '', label: 'Overall' }],
  teams: [{ value: '', label: 'Overall' }],
  reportingManagers: [{ value: '', label: 'Overall' }],
  saleTypes: [{ value: '', label: 'Overall' }],
};

export const downloadTypes = {
  PDF: 'PDF',
  EXCEL: 'Excel',
  CSV: 'CSV',
};
export const downloadTypesTrust = {
  EXCEL: 'Excel',
  CSV: 'CSV',
};

export const downloadTypesEmail = [
  {
    label: 'Download as PDF Format',
    value: 'pdf',
  },
  {
    label: 'Download as Excel Format',
    value: 'excel',
  },
  {
    label: 'Download as CSV Format',
    value: 'csv',
  },
];
export const reports = {
  AR_AGING: 'arAgingReport',
  FUTURE_DEED_REPORT: 'futurePaidinFullReport',
  PAY_OFF_REPORT: 'payOffReport',
  PAY_OFF_REPORT_CALCULATE: 'payOffReportCalculate',
  INTEREST_AND_FINANCE_BY_CUSTOMER: 'interestAndFinancebyCustomer',
  AR_AGING_DETAIL_REPORT: 'arAgingDetailedReport',
  UNPAID_TRANSACTION_REPORT: 'unpaidTransactionReport',
  EQUITY_ON_CANCELLED_CONTRACT: 'equityOnCancelledContract',
  PIA_EXCEPTION_REPORT: 'PIAExceptionReport',
  INDIVIDUAL: 'individual',
  BULK: 'bulk',
  AR_ADJUSTMENT_REPORT: 'arAdjustmentReport',
  CASH_JOURNAL: 'cashJournal',
  SALES_JOURNAL: 'salesJournal',
  COMMISSION_JOURNAL: 'commissionJournal',
  GENERAL_JOURNAL: 'generalJournal',
  TRUST_ACCOUNT_DETAILS: 'trustDetailsReport',
  TRUST_ITEMS_REPORT: 'trustItemsReport',
  NEGATIVE_DUE_REPORT: 'negativeDueReport',
  OVER_DUE_EXCEPTION_REPORT: 'pastDueReport',
};
export const agreementNeedTypeLabels = {
  AN: 'At Need',
  PN: 'Pre Need',
};
export const dateFormat = {
  YEAR_MONTH_DAY: 'YYYY-MM-DD',
  D_M_Y: 'd M Y',
  M_D_Y: 'm/d/Y',
};

export const arAgingDetailsTableColumns = [
  'SL.NO',
  'PURCHASER NAME',
  'AGREEMENT TYPE',
  'CONTRACT DATE',
  'PAST DUE DAYS',
  'TOTAL AMOUNT',
  'CURRENT DUE',
  'PAST DUE',
  '0-30 DAYS',
  '31-60 DAYS',
  '61-90 DAYS',
  '91-120 DAYS',
  'ABOVE 120 DAYS',
  'TYPE',
  'SUB-TYPE',
  'ANTICIPATED VALUE',
];
export const PayOffReportTableColumns = [
  'CONTRACT ID',
  'OPI ID',
  'PURCHASER NAME',
  'LOCATION',
  'TOTAL CONTRACT VALUE',
  'ACTION',
];
export const PayOffInfoTableColumns = [
  'ORIGINAL PRINCIPAL',
  'ORIGINAL INTEREST',
  'PAYOFF AMOUNT',
  'INTEREST SAVINGS',
  'INTEREST PAID',
  'Principal Paid',
];

export const aRAgingTableColumns = [
  'ENTITY',
  'TOTAL AMOUNT',
  'CURRENT DUE',
  'PAST DUE',
  '0-30 DAYS',
  '31-60 DAYS',
  '61-90 DAYS',
  '91-120 DAYS',
  'ABOVE 120 DAYS',
];

export const pnFuneralTrustAgingTableColumns = [
  'ENTITY',
  'CONTRACT AMOUNT',
  'DOWNPAYMENT',
  'MONTHLY PAYMENT',
  'CURRENT DUE',
  'PAST DUE',
  '0-30 DAYS',
  '31-60 DAYS',
  '61-90 DAYS',
  '91-120 DAYS',
  '121-640 DAYS',
  '641-670 DAYS',
  '671-700 DAYS',
  '701-730 DAYS',
  'ABOVE 730 DAYS',
];

export const pnFuneralTrustAgingDetailesTableColumns = [
  'SL.NO',
  'PURCHASER NAME',
  'AGREEMENT TYPE',
  'CONTRACT DATE',
  'CONTRACT AMOUNT',
  'DOWNPAYMENT',
  'MONTHLY PAYMENT',
  'CURRENT DUE',
  'PAST DUE',
  '0-30 DAYS',
  '31-60 DAYS',
  '61-90 DAYS',
  '91-120 DAYS',
  '121-640 DAYS',
  '641-670 DAYS',
  '671-700 DAYS',
  '701-730 DAYS',
  'ABOVE 730 DAYS',
];

export const piaExceptionReportColumns = [
  'S.NO',
  'OPID',
  'CONTRACT ID',
  'PURCHASER NAME',
  'REMAINING INTEREST',
  'REMAINING DUE',
  'LOCATION',
  'AGREEMENT TYPE',
];
export const nestedHeaders = ['EQUITY', 'OTHER INCOME'];
export const ECCTableColumns = {
  'PURCHASER OPI': null,
  'PURCHASER NAME': null,
  'PARTICULAR CONTRACT ID': null,
  '0-12M': nestedHeaders,
  '13-24M': nestedHeaders,
  '25-36M': nestedHeaders,
  'ABOVE 36': nestedHeaders,
};
export const futurePaidinFulltableColumns = [
  'SL. NO.',
  'purchaser Name',
  'AGREEMENT TYPE',
  'Due Amount',
  'Due date',
  'Counselor name',
  'manager name',
];

export const unpaidTransactionTableColumns = [
  'CONTRACT NUMBER',
  'TOTAL CONTRACT VALUE',
  'DUE AMOUNT',
  'CURRENT / PAST DUE',
  'CEMETERY/FUNERAL/WHOLESALE',
  'LOCATION',
  'ARRANGER',
  'CREATED DATE',
  'SUBMISSION DATE',
  'LAST PAYMENT DATE',
  'LAST SCHEDULED PAY DATE',
  'FINANCING TERM & REPAYMENT #',
  'PAYOR NAME & ADDRESS',
  '0-30',
  '31-60',
  '61-90',
  '91-120',
  'ABOVE 120',
];
export const individualTableColumns = [
  'SL.NO.',
  'DATE',
  'Contract ID',
  'OPI ID',
  'DESCRIPTION',
  'AMOUNT',
  'PAYMENT',
  'ADJUSTMENT',
  'BALANCE DUE',
];
export const individualSummaryTableColumns = [
  'CURRENT',
  '0-30 DAYS',
  '31-60 DAYS',
  '61-90 DAYS',
  '91-120 DAYS',
  'ABOVE 120 DAYS',
];
export const bulkTableColumn = [
  'SL.NO.',
  'PURCHASER OPI',
  'PURCHASER NAME',
  'BILLS',
  'PAYMENTS',
  'ADJUSTMENTS',
  'BALANCE DUE',
];
export const accountNumberTableColumn = [
  '',
  'ACCOUNT',
  'DESCRIPTION',
  'CEMETERY',
  'FUNERAL',
  'CREMATION',
  'SPECIAL CARE TRUST',
  'ENDOWMENT CARE TRUST',
  'PN FUNERAL TRUST',
  'PN FUNERAL TRUST-GA',
  'PN Funeral Insurance',
];
export const gLTemplateTableColumn = [
  'AC SET',
  'ACCOUNT NUMBER',
  'DESCRIPTION',
  'DEBIT',
  'CREDIT',
  '% ALLOCATION',
];
export const arAdjustmentNestedHeaders = [
  'TOTAL CONTRACT VALUE',
  'BAD DEBT',
  // 'WRITE OFF',
  'LATE FEE',
  // 'LATE FEE WAIVER',
  // 'ADVANCE',
  'PROMO DISCOUNT',
  'OTHER DISCOUNT',
  'ADJUSTMENT',
  'BALANCE',
];
export const arAdjustmentTableColumns = {
  'Purchaser OPI': null,
  'Purchaser Name': null,
  'Contract ID': null,
  'Adjustments ': arAdjustmentNestedHeaders,
};
export const journals = {
  SALES_JOURNAL: 'salesJournal',
  COMMISSION_JOURNAL: 'commissionJournal',
  CASH_JOURNAL: 'cashJournal',
  GENERAL_JOURNAL: 'generalJournal',
  TRUST_JOURNAL: 'trustJournal',
};

export const GLExceptionTableColumns = [
  'SR.NO',
  'DATE',
  'CONTRACT NUMBER',
  'PURCHASER ID',
  'EVENT',
  'REASON',
  'ACTION',
];
export const TrustGLExceptionTableColumns = [
  'SR.NO',
  'DATE',
  'CONTRACT NUMBER',
  'PURCHASER ID',
  'EVENT',
  'REASON',
  'GL LOCATION NAME',
  'ACTION',
];

export const trustAccounts = ['S.NO', 'LIST OF CONTRACTS', 'STATUS', 'IN PROGRESS', '', ''];

export const defaultTrustContractHeader = ['S.NO', 'LIST OF CONTRACTS', 'STATUS', '', ''];

export const closedTrustContractHeader = ['S.NO', 'LIST OF CONTRACTS', 'STATUS', '', ''];

export const equityOnCancelledContractHeader = ['S.NO', 'LIST OF CONTRACTS', 'STATUS', '', ''];

export const trustedConsumptionItemsHeader = [
  { headerValue: 'Category', headerText: 'Category' },
  { headerValue: 'itemUsageId', headerText: 'Item Usage Id' },
  {
    headerValue: 'contractSubmissionDate',
    headerText: 'Contract Submission Date',
    type: 'date',
  },
  { headerValue: 'contractNumber', headerText: 'Contract Number' },
  {
    headerValue: 'addendumSubmissionDate',
    headerText: 'Addendum Submission Date',
    type: 'date',
  },
  { headerValue: 'addendumNumber', headerText: 'Addendum Number' },
  {
    headerValue: 'consumptionDate',
    headerText: 'Consumption Date',
    type: 'date',
  },
  { headerValue: 'itemCode', headerText: 'Item Code' },
  {
    headerValue: 'assignmentAndTransfer',
    headerText: 'Assignment And Transfer',
  },
  {
    headerValue: 'itemNameOrPropertyName',
    headerText: 'Item Name Or Property Name',
  },
  { headerValue: 'totalPrice', headerText: 'Total Price', type: 'price' },
  { headerValue: 'lotSpaceId', headerText: 'Lot Space Id' },
  { headerValue: 'lotSellUnitId', headerText: 'Lot Sell Unit Id' },
  { headerValue: 'propertyId', headerText: 'Property Id' },
  {
    headerValue: 'itemUsageUpdatedAt',
    headerText: 'Item Usage Updated At',
    type: 'date',
  },
  { headerValue: 'itemUsageUpdatedBy', headerText: 'Item Usage Updated By' },
  {
    headerValue: 'itemUsageCreatedAt',
    headerText: 'Item Usage Created At',
    type: 'date',
  },
  { headerValue: 'itemUsageCreatedBy', headerText: 'Item Usage Created By' },
];

export const trustedSalesItemsHeader = [
  { headerValue: 'event', headerText: 'Event' },
  {
    headerValue: 'contractSubmissionDate',
    headerText: 'Contract Submission Date',
    type: 'date',
  },
  { headerValue: 'contractNumber', headerText: 'Contract Number' },
  {
    headerValue: 'addendumSubmissionDate',
    headerText: 'Addendum Submission Date',
    type: 'date',
  },
  { headerValue: 'addendumNumber', headerText: 'Addendum Number' },
  { headerValue: 'itemCode', headerText: 'Item Code' },
  { headerValue: 'itemName', headerText: 'Item Name' },
  { headerValue: 'itemQuantity', headerText: 'Item Quantity', type: 'number' },
  { headerValue: 'totalPrice', headerText: 'Total Price', type: 'price' },
  { headerValue: 'isRemoved', headerText: 'Is Removed', type: 'boolean' },
];

export const endowmentCareSalesPropertyHeader = [
  { headerValue: 'Category', headerText: 'Category' },
  { headerValue: 'event', headerText: 'Event' },
  {
    headerValue: 'contractSubmissionDate',
    headerText: 'Contract Submission Date',
    type: 'date',
  },
  { headerValue: 'contractNumber', headerText: 'Contract Number' },
  {
    headerValue: 'addendumSubmissionDate',
    headerText: 'Addendum Submission Date',
    type: 'date',
  },
  { headerValue: 'addendumNumber', headerText: 'Addendum Number' },
  { headerValue: 'itemCode', headerText: 'Item Code' },
  {
    headerValue: 'itemNameOrPropertyName',
    headerText: 'Item Name Or Property Name',
  },
  { headerValue: 'lotSellUnitId', headerText: 'Lot Sell Unit Id' },
  { headerValue: 'itemQuantity', headerText: 'Item Quantity', type: 'number' },
  { headerValue: 'ecfPrice', headerText: 'Ecf Price', type: 'price' },
  { headerValue: 'propertyId', headerText: 'Property Id' },
  { headerValue: 'isRemoved', headerText: 'Is Removed', type: 'boolean' },
];

export const detailedContractHeader = [
  {
    headerValue: 'paymentDate',
    headerText: 'Date of Payment/ Contract',
    type: 'date',
  },
  { headerValue: 'paymentId', headerText: 'Payment ID' },
  { headerValue: 'contractNumber', headerText: 'Contract Number' },
  { headerValue: 'onePortalId', headerText: 'Beneficiary OPI' },
  { headerValue: 'businessUnit', headerText: 'Business Unit' },
  { headerValue: 'subUnit', headerText: 'Sub Unit (Entity)' },
  { headerValue: 'transactionType', headerText: 'Transaction Type' },
  { headerValue: 'amount', headerText: 'Amount', type: 'price' },
  { headerValue: 'bifurcation', headerText: 'Bifurcation' },
];

export const trustAccountsPayable = ['ITEM', 'VALUE', 'DOWNPAYMENT'];

export const trustAccountsPaid = ['ITEM', 'VALUE', 'DOWNPAYMENT'];
export const particularHeaders = ['PURCHASER OPI', 'PURCHASER NAME', 'CONTRACT ID'];
export const EquityHeaders = ['EQUITY', 'OTHER INCOME'];
export const equityTableColumns = {
  PARTICULARS: particularHeaders,
  '0-12 MONTHS': EquityHeaders,
  '13-24 MONTHS': EquityHeaders,
  '25-36 MONTHS': EquityHeaders,
  'ABOVE 36': EquityHeaders,
};

export const defaultTrustAccounts = ['S.NO', 'LIST OF CONTRACTS', 'STATUS', ''];
export const journalsTitles = {
  salesJournal: 'Sales Journal',
  commissionJournal: 'Commission Journal',
  cashJournal: 'Cash Journal',
  generalJournal: 'General Journal',
  trustJournal: 'Trust Journal',
};

export const trustItemsHeaders = [
  'RESOURCE TYPE',
  'SALES ITEM ID',
  'SALES CONTRACT NUMBER',
  'SALES DATE',
  'CATEGORY',
  'PRODUCT ITEM CODE',
  'ASSIGNMENT/TRANSFER',
  'ITEM CODE DESCRIPTION',
  'SALES PRICE',
  'UNIT TAX',
  'SALES COST',
  'DUE',
  'RECEIVED',
];

export const trustDyanamicItemWisePayementsSections = [
  { title: 'Properties', keyTobeMapped: 'properties' },
  { title: 'Services', keyTobeMapped: 'services' },
  { title: 'Merchandises', keyTobeMapped: 'merchandises' },
  { title: 'Memorials', keyTobeMapped: 'memorials' },
  { title: 'Discounts', keyTobeMapped: 'discounts' },
  { title: 'Adjustments', keyTobeMapped: 'adjustments' },
];

export const maxLimitTrustItems = [
  { value: 100, label: '100' },
  { value: 500, label: '500' },
  { value: 1000, label: '1000' },
  { value: 1500, label: '1500' },
  { value: 2000, label: '2000' },
];

export const arDropdownPrefixedData = {
  types: [{ value: '', label: 'Overall' }],
  subTypes: [{ value: '', label: 'Overall', category: 'Overall' }],
};
export const generateTypes = [
  {
    label: 'Generate One Portal contracts only',
    value: 'onePortal',
  },
  {
    label: `Generate from last month's summary table.`,
    value: 'lastSummary',
  },
  {
    label: 'Do not generate',
    value: 'doNotGenerate',
  },
];
export const commonMultiSelectFiltersPrefixedData = {
  entity: [],
  businessUnits: [],
  agreementTypes: [],
  teams: [],
  reportingManagers: [],
  saleTypes: [],
};

export const fetchMultiSelectData = (multiSelectData, defaults) => {
  const prepareParams = (type) => {
    if (multiSelectData[type].length === defaults[type].length) return '';
    return multiSelectData[type].map((each) => each).join(',') || '';
  };

  return {
    entity: prepareParams('entity'),
    businessUnit: prepareParams('businessUnits'),
    team: prepareParams('teams'),
    reportingManager: prepareParams('reportingManagers'),
    saleType: prepareParams('saleTypes'),
    needType: prepareParams('agreementTypes'),
  };
};

export const fetchDashboardFilterData = (multiSelectData) => {
  if (multiSelectData.entity.length === 0) {
    const err = new Error();
    err.name = 'COMMON_FILTER_ERROR';
    throw err;
  }
  const prepareParams = (type) => {
    return multiSelectData[type].map((each) => each).join(',') || '';
  };

  return {
    entity: prepareParams('entity'),
    businessUnit: prepareParams('businessUnits'),
    departments: prepareParams('departments'),
    salesManagers: prepareParams('salesManagers'),
    unitManagers: prepareParams('unitManagers'),
  };
};

export const negativeDueReportColumns = [
  'S.NO',
  'OPID',
  'PURCHASER NAME',
  'CONTRACT ID',
  'ADDENDUM STATUS',
  'SUBMITTED DATE',
  'TOTAL PRICE',
  'TAX',
  'PURCHASE PRICE',
  'ADJUSTMENT',
  'CASH PRICE',
  'TOTAL PAID',
  'BALANCE DUE',
];

export const overDueExceptionReportColumns = [
  'S.NO',
  'PURCHASER OPI',
  'PURCHASER NAME',
  'CONTRACT NUMBER',
  'ADDENDUM STATUS',
  'SUBMISSION DATE',
  'EXPECTED PAYMENT DATE',
  'ORIGINAL PRINCIPAL / PAYMENT',
  'ORIGINAL INTEREST',
  'REMAINING PRINCIPAL / PAYMENT',
  'REMAINING INTEREST',
  'DAYS OVERDUE',
  'LAST PAYMENT DATE',
];

export const pastDueDaysFilters = [
  { label: 'Custom', key: 0, value: { from: '', to: '' } },
  { label: '0 - 30', key: 1, value: { from: 0, to: 30 } },
  { label: '31 - 60', key: 2, value: { from: 31, to: 60 } },
  { label: '61 - 90', key: 3, value: { from: 61, to: 90 } },
  { label: '91 - 120', key: 4, value: { from: 91, to: 120 } },
  { label: 'Above 120', key: 5, value: { from: 120, to: '' } },
];

export const TrustEntities = [
  {
    value: 'C-1',
    label: 'Cypress lawn special care trust',
  },
  {
    value: 'C-2',
    label: 'Olivet memorial special care trust',
  },
];
